var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "search", class: _vm.searchActive ? "search-active" : "" },
    [
      _c(
        "button",
        {
          staticClass: "search__button",
          attrs: {
            "aria-expanded": _vm.searchActive.toString(),
            "aria-controls": "search-input",
            title: "Search"
          },
          on: {
            click: function($event) {
              return _vm.toggleSearch()
            }
          }
        },
        [
          _c("span", {
            staticClass: "search__button--label",
            domProps: {
              textContent: _vm._s(
                _vm.searchActive ? "Close Search" : "Open Search"
              )
            }
          }),
          _vm._v(" "),
          _c("span", { staticClass: "search__button-icon--wrapper" }, [
            _c(
              "svg",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.searchActive,
                    expression: "!searchActive"
                  }
                ],
                staticClass: "search__button-icon",
                attrs: { viewBox: "0 0 13.22 13.19" }
              },
              [
                _c("use", {
                  attrs: {
                    "xlink:href":
                      "/o/udliferay-theme/images/symbols/search-icon.svg#search-icon"
                  }
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "svg",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.searchActive,
                    expression: "searchActive"
                  }
                ],
                staticClass: "search__button-icon",
                attrs: { viewBox: "0 0 12.06 12.06" }
              },
              [
                _c("use", {
                  attrs: {
                    "xlink:href":
                      "/o/udliferay-theme/images/symbols/close-icon.svg#close-icon"
                  }
                })
              ]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "form",
        {
          staticClass: "search__form",
          attrs: { id: _vm.id, action: "/group/porches/search" }
        },
        [
          _c("input", {
            attrs: {
              name: "cx",
              type: "hidden",
              value: "005091531186671414747:zv6fhtza838"
            }
          }),
          _vm._v(" "),
          _c("input", {
            attrs: { name: "cof", type: "hidden", value: "FORID:11" }
          }),
          _vm._v(" "),
          _c("input", {
            attrs: { name: "ie", type: "hidden", value: "UTF-8" }
          }),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "search__input--label",
              attrs: { for: _vm.inputid }
            },
            [_vm._v("\n            Search\n        ")]
          ),
          _vm._v(" "),
          _c("input", {
            ref: "searchInput",
            staticClass: "search__input",
            class: _vm.searchActive ? "search-active" : null,
            attrs: {
              id: "search-input",
              disabled: !_vm.searchActive,
              id: _vm.inputid,
              name: "q",
              type: "search",
              placeholder: "Search"
            }
          }),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "search__submit",
              attrs: { type: "submit", name: "sa" }
            },
            [
              _c("span", { staticClass: "search__submit--label" }, [
                _vm._v("Submit")
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "search__submit-icon--wrapper" }, [
                _c(
                  "svg",
                  {
                    staticClass: "search__submit-icon",
                    attrs: { viewBox: "0 0 13.75 12.16" }
                  },
                  [
                    _c("use", {
                      attrs: {
                        "xlink:href":
                          "/o/udliferay-theme/images/symbols/arrow-icon.svg#arrow-icon"
                      }
                    })
                  ]
                )
              ])
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-23937b02", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23937b02","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UtilitySearchPorches.vue
// module id = null
// module chunks = 